import { useRouter } from 'next/router'

import { LOCALES } from '@constants/locales'

export const useCountryCode = () => {
  const router = useRouter()
  return router?.query?.country?.toLowerCase() ?? LOCALES.UNITED_KINGDOM
}
